module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_btn03-b862ae8cb07de5759b75f2827af5f745.png";